/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'


// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import _ from 'lodash';
Vue.use(Vuesax)
Vue.use(require('vue-moment'));

// axios
import axios from "./axios.js"
axios.defaults.baseURL = process.env.VUE_APP_API_URL
const accessToken = localStorage.getItem('accessToken')
if (accessToken) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
        // axios.defaults.headers.common['Access-Control-Request-Headers'] = null
        // axios.defaults.headers.common['Access-Control-Request-Method'] = null
}
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

import 'vue-simple-suggest/dist/styles.css'

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Vuexy Admin Filters
import './filters/filters'

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'AIzaSyBW_pEAMblXH7jr_-Csj8Drhv7Ee5i2D10',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

Object.defineProperty(Vue.prototype, '$_', { value: _ });


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')